import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

export default class extends Controller {
  static values = { cookieName: String, cookieValue: String };

  connect() {
    this.element.addEventListener('hidden.bs.modal', this.remember);
    Modal.getOrCreateInstance(this.element).show();
  }

  disconnect() {
    this.element.removeEventListener('hidden.bs.modal', this.remember);
  }

  remember = () => {
    const maxAge = 60 * 60 * 24 * 62;
    document.cookie = `${this.cookieNameValue}=${this.cookieValueValue}; path=/; max-age=${maxAge}; SameSite=Lax`;
  };
}
